import React from "react";
import "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReact, faDocker, faPython } from "@fortawesome/free-brands-svg-icons";
import Chip from "@mui/material/Chip";
import "../assets/styles/Expertise.scss";
import { useTranslation } from "react-i18next";

const labelsFirst = [
  "React",
  "TypeScript",
  "JavaScript",
  "HTML5",
  "CSS3",
  "SASS",
  "Flask",
  "Python",
  "SQL",
  "PostgreSQL",
  "Postman"
];

const labelsSecond = [
  "Git",
  "GitHub Actions",
  "Docker",
//   "AWS",
//   "Azure",
  "Linux",
//   "Snowflake",
  "Pandas",
  "Selenium"
];

const labelsThird = [
  "OpenAI",
//   "Groq",
  "LangChain",
//   "Qdrant",
  "Hugging Face",
  "LlamaIndex",
  "Streamlit"
];

function Expertise() {
  const { t } = useTranslation();

  return (
    <div className="container" id="expertise">
      <div className="skills-container">
        <h1>{t("expertise")}</h1>

        <div className="skills-grid">
          <div className="skill">
            <FontAwesomeIcon icon={faReact} size="3x" />
            <h3>Full Stack</h3>
            <p>{t("expertise_text.stack")}</p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsFirst.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon icon={faPython} size="3x" />
            <h3>Artificial Intelligence & Computer Vision</h3>
            <p>{t("expertise_text.ai")}</p>
            <div className="flex-chips">
              <span className="chip-title">AI stack:</span>
              {labelsThird.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>
          
          <div className="skill">
            <FontAwesomeIcon icon={faDocker} size="3x" />
            <h3>DevOps</h3>
            <p>{t("expertise_text.infra")}</p>
            <div className="flex-chips">
              <span className="chip-title">Tools:</span>
              {labelsSecond.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Expertise;